import { FC } from 'react'
import Icon from '@assets/icon_config';
import "./richText.scss"
import { Tooltip } from 'antd'

interface CustomControlsProps {
    bookmarkStatus?: any;
    setBookmarkStatus?: any;
    recipientType?: any;
    setRecipientType?: any 
}

const CustomControls: FC<CustomControlsProps> =({ bookmarkStatus, setBookmarkStatus, recipientType, setRecipientType }: CustomControlsProps) => {
  const title = "Note To PCP"
  const onclickBookmarkHandler = () => {
    setBookmarkStatus({ ...bookmarkStatus, isBookmarked: !bookmarkStatus.isBookmarked });
  };

  const onclickRecipientHandler = () => {
    setRecipientType(!recipientType);
  };

  return (
    <div className='richTextArea__custom-control-container'>
      <Tooltip placement="bottom" title={title}>
        <span className='f20 clr-themeColor richTextArea__custom-control-container__icon' onClick={onclickRecipientHandler}>
            <Icon name={recipientType ? 'fill-pcp-note' : 'pcp-note'} />
        </span>
      </Tooltip>
      <span className='f20 clr-themeColor richTextArea__custom-control-container__icon' style={{ marginLeft: '0.5rem' }} onClick={onclickBookmarkHandler}>
        <Icon name={bookmarkStatus.isBookmarked ? 'fill-bookmark-note' : 'bookmark-note'} />
      </span>
    </div>
  );
}

export default CustomControls;